import React, { useState } from 'react';
import './FindDealerPage.css';
import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const countryList = [
  'United States', 'United Kingdom', 'United Arab Emirates', 'India', 'Germany', 'France', 
  'Singapore', 'Malaysia', 'Australia', 'Canada', 'Other'
];

const dealers = [
  {
    region: 'UK & Europe',
    name: 'London Laser Group',
    location: 'Holborn, London, UK – WC1X 8SF',
    email: 'lonlasergp@gmail.com'
  },
  {
    region: 'Middle East',
    name: 'Tint My Ride',
    location: 'Shuwaikh, Kuwait',
    email: 'info@tintmyridekuwait.com'
  },
  {
    region: 'India',
    name: 'International Glass Works',
    location: 'Connaught Place, Delhi – 110001, India',
    email: 'Intglassworks@gmail.com'
  }
];

const FindDealerPage = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    country: '',
    city: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (error) setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const formData = {
        ...form,
        type: 'dealer-inquiry',
        status: 'pending',
        submittedAt: serverTimestamp()
      };

      await addDoc(collection(db, 'contact-inquiries'), formData);
      
      setSubmitted(true);
      setForm({
        name: '',
        email: '',
        country: '',
        city: '',
        phone: '',
        message: ''
      });
    } catch (err) {
      console.error('Error submitting form:', err);
      setError('There was an error submitting your inquiry. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="find-dealer-main">
      <section className="find-dealer-hero">
        <h1>🌍 Find a Dealer</h1>
        <p>Looking to buy or install Derma Protec Films near you? Connect with our trusted dealers across the globe for genuine products, expert installation, and warranty-backed service.</p>
      </section>

      <section className="dealers-section">
        <div className="dealers-grid">
          {dealers.map(dealer => (
            <div key={dealer.name} className="dealer-card">
              <h3 className="dealer-region">{dealer.region}</h3>
              <h4 className="dealer-name">{dealer.name}</h4>
              <div className="dealer-details">
                <p className="dealer-location">📍 {dealer.location}</p>
                <a href={`mailto:${dealer.email}`} className="dealer-email">📧 {dealer.email}</a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="other-countries-section">
        <div className="other-countries-content">
          <h2>🌎 Other Countries</h2>
          <p>We're expanding! If you're located outside the listed regions, contact us directly and we'll assist you with your query or connect you with our global partners.</p>
          
          <div className="contact-info">
            <h3>📩 General Inquiries</h3>
            <a href="mailto:info@dermaprotecfilms.com" className="contact-email">📧 info@dermaprotecfilms.com</a>
          </div>

          <div className="contact-form-section">
            <h3>📬 Or, fill in the form below:</h3>
            <h4>✉️ Contact Us</h4>
            
            {submitted ? (
              <div className="contact-success">
                Thank you for your inquiry! We will get back to you soon.
              </div>
            ) : (
              <>
                {error && <div className="contact-error">{error}</div>}
                <form className="contact-form" onSubmit={handleSubmit}>
                  <label>Name <span className="required">*</span>
                    <input
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      required
                      placeholder="Your Full Name"
                      disabled={loading}
                    />
                  </label>
                  
                  <label>Email <span className="required">*</span>
                    <input
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      placeholder="example@example.com"
                      disabled={loading}
                    />
                  </label>
                  
                  <div className="form-row">
                    <label>Country <span className="required">*</span>
                      <select
                        name="country"
                        value={form.country}
                        onChange={handleChange}
                        required
                        disabled={loading}
                      >
                        <option value="">Choose Your Country</option>
                        {countryList.map(country => (
                          <option key={country} value={country}>{country}</option>
                        ))}
                      </select>
                    </label>
                    
                    <label>City / Region <span className="required">*</span>
                      <input
                        name="city"
                        value={form.city}
                        onChange={handleChange}
                        required
                        placeholder="Your City / Area"
                        disabled={loading}
                      />
                    </label>
                  </div>
                  
                  <label>Phone (Optional)
                    <input
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="+123456789"
                      disabled={loading}
                    />
                  </label>
                  
                  <label>How can we help you? <span className="required">*</span>
                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      required
                      placeholder="Describe your inquiry"
                      disabled={loading}
                    />
                  </label>
                  
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={loading}
                  >
                    {loading ? 'Submitting...' : 'Submit Inquiry'}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default FindDealerPage; 